import React from 'react';
import { Link } from 'react-router-dom';

const CreateConfirm = ({ message, handleSubmit, handleFocusReset }) => {
    const form_action = message === 'Quit' ? 'quit' : 'submit';
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1001,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
            <div
                style={{
                    width: '10%',
                    height: '100px',
                    borderWidth: 1,
                    borderColor: 'black',
                    borderStyle: 'solid',
                    background: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <p className='modal_message'>
                                {message} ?
                            </p>
                        </div>
                        <div className='col-12'>
                            <div className='row justify-content-center'>
                                <div className='col-3 m-0 p-0'>
                                    {/* <Link className="modal_link" onClick={() => { return (handleSubmit(new Event('submit'))) }} >Yes</Link> */}
                                    <Link style={{ textDecoration: 'none', color: '#000' }} className="modal_link" onClick={() => { return (handleSubmit(new Event(form_action))) }} ><span style={{ color: 'red' }}>Y</span>es </Link>
                                </div>
                                <div className='col-2'>or</div>
                                <div className='col-3'>
                                    <Link style={{ textDecoration: 'none', color: '#000' }} className='modal_link' onClick={() => { return (handleFocusReset()) }}><span style={{ color: 'red' }}>N</span>o</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(CreateConfirm)
